module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-4.1b101501.PNG";